module.exports = __webpack_public_path__ + "static/media/logoLogin.ffd4f451.png";